import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Legend, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const donutColors = ["#FF85B6", "#57FFFF"];

const CombinedCharts = ({ graphROI }) => {
  const [pieChartData, setPieChartData] = useState([]);
  const [waterfallData, setWaterfallData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);


  useEffect(() => {
    if (graphROI) {
      if (graphROI?.pieChartData) {
        setPieChartData([
          { name: graphROI?.pieChartData.type, value: graphROI?.pieChartData.ownership },
          { name: "Company", value: graphROI?.pieChartData.company }
        ]);
      }
      if (graphROI?.waterFallChartData) {
        let cumulative = 0;
        let inValue = 0;
        let waterFallChart = [...graphROI?.waterFallChartData?.data]?.slice().reverse();

        const formattedWaterfallData = waterFallChart?.map((item, index) => {
          let value = parseFloat(item.amount);
          let pv = cumulative;
          let name;
          let color = "#57FFFF";

          if (item.type === "IN") {
            name = "IN";
            inValue = value;
          } else if (item.type === "VALUATION") {
            name = "VALUATION";
            value = value - inValue;
          } else if (item.type === "EXPENSE") {
            name = "EXPENSE";
            value = -Math.abs(value);
            color = "#FF85B6";
          } else {
            name = "INCOME";
          }

          cumulative += value;

          return { name, value, pv, color };
        }) || [];
        formattedWaterfallData.push({
          name: "Subtotal",
          value: parseFloat(graphROI.waterFallChartData.subtotal),
          pv: 0,
          color: "rgb(219, 215, 215)"
        });

        setWaterfallData(formattedWaterfallData);
      }
    }
  }, [graphROI]);

  return (
    <div className="flex gap-6 justify-center items-center">
      <ResponsiveContainer width="40%" height={400} className="border border-gray-600">
        <PieChart>
          <Tooltip
            cursor={{ fill: "none" }}
            content={({ payload }) => {
              if (!payload || payload.length === 0) return null;

              return (
                <div className="bg-white text-primary p-4 rounded shadow-md text-sm">
                  <div><strong>{payload[0]?.payload.name}: {payload[0]?.payload.value}</strong></div>
                </div>
              );
            }}
          />
          <Pie
            data={pieChartData}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            paddingAngle={2}
            dataKey="value"
            onMouseEnter={(_, index) => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(null)}
            activeIndex={activeIndex}
            activeShape={{ outerRadius: 90 }}
          >
            {pieChartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={donutColors[index]} />
            ))}
          </Pie>

          <Legend
            verticalAlign="bottom"
            align="center"
            content={() => (
              <div className="flex justify-center gap-4 mt-2">
                {pieChartData.map((entry, index) => (
                  <div key={index} className="flex items-center gap-1">
                    <div
                      style={{
                        width: 12,
                        height: 12,
                        backgroundColor: donutColors[index],
                        borderRadius: 2
                      }}
                    ></div>
                    <span style={{ color: "white", fontSize: "14px" }}>{entry.name}</span>
                  </div>
                ))}
              </div>
            )}
          />

        </PieChart>
      </ResponsiveContainer>


      <ResponsiveContainer width="50%" height={400} className="border border-gray-600 p-4">
        <BarChart data={waterfallData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 0" vertical={false} />
          <XAxis dataKey="name" tickLine={false} tickFormatter={(value) => (value === "Subtotal" ? value : "")} />
          <YAxis axisLine={false} tickLine={false} />
          <Tooltip
            cursor={{ fill: "none" }}
            content={({ payload }) => {
              if (!payload || payload.length === 0) return null;

              return (
                <div className="bg-white text-primary p-4 rounded shadow-md text-sm">
                  <div><strong>{payload[0]?.payload.name}: {payload[0]?.payload.value}</strong></div>
                </div>
              );
            }}
          />

          <Legend
            verticalAlign="bottom"
            align="center"
            content={() => (
              <div className="flex justify-center gap-4 mt-2">
                {[
                  { value: "INCOME", color: "#57FFFF" },
                  { value: "EXPENSE", color: "#FF85B6" },
                  { value: "IN", color: "#57FFFF" },
                  { value: "VALUATION", color: "#57FFFF" }
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-1">
                    <div
                      style={{
                        width: 12,
                        height: 12,
                        backgroundColor: item.color,
                        borderRadius: 2
                      }}
                    ></div>
                    <span style={{ color: "white", fontSize: "14px" }}>{item.value}</span>
                  </div>
                ))}
              </div>
            )}
          />

          <Bar dataKey="pv" stackId="a" fill="transparent" />
          <Bar dataKey="value" stackId="a">
            {waterfallData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.color}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CombinedCharts;
